import React from 'react'
import { ArrowLeft, ArrowRight } from 'lucide-react';
import './BackNavHeader.css'
import Heading6Regular from '../../designSystem/Heading6Regular';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';


function BackNavHeader ({text, onBack}) {
  const isRTL = document.body.dir === "rtl";
  const history = useHistory();

  return (
  <div className='back-header-container'>
    <div className="back-button-container">
      <button className='back-button' onClick={onBack} >
        {isRTL ? <ArrowRight size={20} color="#1E293B"/> :  <ArrowLeft size={20} color="#1E293B" />}
      </button>
    </div>
    <div className='back-heading-container'>
      <Heading6Regular text={text} color='#1E293B' />
    </div>
</div>
  )
}

export default BackNavHeader ;